import { useEffect } from 'react';
import { useChat } from '../ChatProvider';
import { useWindowSession } from '../../app/WindowSession';
import { useAuth } from '../../auth/AuthProvider';
import { confirmsNoCall } from './recovery';
export function CompanionReadiness(){
  const {connected,callsAvailable,callRequest}=useChat();
  const {user}=useAuth();
  const companion=useWindowSession().companion;
  const report=companion?.reportReady, register=companion?.registerRecoveryCheck;
  useEffect(()=>{report?.(connected);return()=>report?.(false);},[connected,report]);
  useEffect(()=>register?.(async()=>{
    if(!connected || !callsAvailable || !user)return false;
    return confirmsNoCall(await callRequest('call_list',{}),user.id);
  }),[register,connected,callsAvailable,callRequest,user]);
  return null;
}
